import RequiredIcon from 'Components/Atoms/RequiredIcon/RequiredIcon';
import WebsiteIcon from 'Components/Atoms/Icons/WebsiteIcon/WebsiteIcon';
import FormGroup from 'Components/Molecules/Form/FormGroup/FormGroup';
import FormSection from 'Components/Molecules/Form/FormSection/FormSection';
import Field from 'Pages/Dashboard/Settings/FieldsManagement/Fields/FieldTypes/Field';
import { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { FieldType } from 'Store/FieldManagement/PropTypes';
import { StoreState } from 'Store/Reducers';
import { getFieldsById } from 'Store/Settings/Fields/Selectors';

const CategoryStep = ({
    fields, handleValidation, onSave, values,
    entity,

    fieldsById
}: CategoryStepProps) => {
    const computedRequiredFieldIds = useMemo(() => fields?.filter(i => fieldsById?.[i]?.required), [fields, fieldsById]);

    const [data, setData] = useState<any>(values);
    useEffect(() => {
        checkValidation(values);
        setData(values);
    }, [values]);

    const checkValidation = (fieldValues?: any) => handleValidation(computedRequiredFieldIds?.every(fieldId => {
        const field = fieldsById?.[fieldId];
        let value = (fieldValues || data)?.[fieldId]?.value;
        if (!value) return false;
        if (field?.type == FieldType.Combination) {
            let isValid = false;
            value.forEach(i => {
                if (isValid) return;

                isValid = field?.default?.fields.every(j => i?.[j]?.length > 0);
            });

            return isValid;
        }

        if (field?.type === FieldType.Address) {
            return !!value?.address;
        }

        if (typeof value == 'number') {
            return value > 0;
        }

        return value?.length > 0;
    }));

    const [debounceChange, setDebounceChange] = useState<any>(null);

    const handleChange = (key, value) => {
        const fieldValues = {
            ...data,
            [key]: {
                ...data?.[key],
                value: value ?? ''
            }
        };

        console.log(fieldValues);
        setData(fieldValues);

        if (debounceChange) {
            clearTimeout(debounceChange);
            setDebounceChange(null);
        }

        setDebounceChange(
            setTimeout(() => {
                onSave(fieldValues);
                checkValidation(fieldValues);
            }, 400)
        );
    };

    return <FormSection>
        {
            fields?.map(i => {
                const field = fieldsById?.[i];
                return <FormGroup
                    key={i}
                    title={field?.name}
                    isPublic={field?.is_public}
                    isRequired={field?.required}
                    isTitle={entity?.name_fields?.includes(field.id)}
                >
                    <Field
                        isEdit={true}
                        value={data?.[field.id]?.value}
                        type={field?.type}
                        required={false}
                        onChange={(value) => handleChange(field.id, value)}
                        fieldProperties={{ ...field.default }}
                    />
                </FormGroup>
            })
        }
    </FormSection>
}

interface Props {
    entity: any
    record_id: string
    handleValidation: any
    onSave: any
    fields: any
    values: any
};

const mapState = (state: StoreState, props: Props) => ({
    fieldsById: getFieldsById(state)
});

const mapDispatch = {

};

type CategoryStepProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(CategoryStep);